<div>
    <div class="buttons-container">
        <button (click)="deleteEventNotification()" mat-stroked-button>
            <mat-icon fontIcon="fa-trash-alt" fontSet="far"></mat-icon>
            <span>Delete</span>
        </button>
        <button
            (click)="saveEventNotification()"
            mat-stroked-button
            style="margin-left: 10px"
            type="submit"
            [disabled]="!notifForm.valid"
        >
            <div class="icon-container-wrap">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    style="position: relative; top: 2px"
                >
                    <g
                        transform="translate(-.005 -.005)"
                        fill="none"
                        fill-rule="evenodd"
                    >
                        <path
                            d="M20.008 11.005V7.564c0-.502-.199-.983-.553-1.337l-2.672-2.672a1.89 1.89 0 0 0-1.337-.554H5.002a2 2 0 0 0-2 2.001v13.006a2 2 0 0 0 2 2h6.003"
                            stroke="#ffffff"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M15 3.001v4.127a.876.876 0 0 1-.876.875H8.872a.876.876 0 0 1-.875-.875V3.001M7.003 20.008v-5.676a1.315 1.315 0 0 1 1.215-1.327h3.787"
                            stroke="#ffffff"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <circle
                            stroke="#ffffff"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            cx="17.507"
                            cy="17.507"
                            r="4.502"
                        />
                        <path
                            stroke="#ffffff"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="m18.907 16.808-1.75 1.752-1.05-1.052"
                        />
                        <path d="M0 0h24.01v24.01H0z" />
                    </g>
                </svg>
            </div>
            <div>Save</div>
        </button>
    </div>
    <form
        (ngSubmit)="saveEventNotification()"
        [formGroup]="notifForm"
        class="notif-fields-container"
    >
        <div class="notif-field">
            <label>Name:</label>
            <div class="display-flex column w-100 mT-4">
                <input
                    formControlName="notificationName"
                    matInput
                    autocomplete="off"
                    class="w-100"
                />
                <mat-error
                    *ngIf="
                        notifForm.get('notificationName').touched &&
                        notifForm.get('notificationName').errors?.required
                    "
                    class="error"
                >
                    Name is required.
                </mat-error>
                <mat-error
                    *ngIf="
                        notifForm.get('notificationName').touched &&
                        notifForm.get('notificationName').errors?.maxlength
                    "
                    class="error"
                >
                    Exceed the maximum.
                </mat-error>
            </div>
        </div>
        <div class="notif-field">
            <label for="overlay">Weather Event:</label>
            <div class="display-flex column w-100 mT-4">
                <mat-select
                    *ngIf="eligibleOverlays?.length"
                    formControlName="overlayId"
                    id="overlay"
                    class="location-address-select"
                >
                    <mat-option
                        (onSelectionChange)="onSelectedOverlayChange($event)"
                        *ngFor="let overlay of eligibleOverlays"
                        [value]="overlay.id"
                        >{{ overlay.name | decodeHtml }}</mat-option
                    >
                </mat-select>
                <mat-select
                    *ngIf="!eligibleOverlays?.length"
                    [disabled]="true"
                    placeholder="No items available"
                    class="location-address-select"
                ></mat-select>
                <mat-error
                    *ngIf="
                        notifForm.get('overlayId').touched &&
                        notifForm.get('overlayId').errors?.required &&
                        eligibleOverlays?.length
                    "
                    class="error"
                >
                    Select a field
                </mat-error>
            </div>
        </div>
        <div
            class="notif-field"
            *ngIf="isActiveEarthquakeSelected()"
        >
            <!-- <label [ngClass]="{ 'error-color': onSaveFormWithoutFilter }"
                >Earthquake Magnitude</label
            > -->
            <div class="magnitude-input-container" style="margin-top: 8px; display: flex; align-items: center;">
                <div style="margin-right: 8px; font-weight: bold;">Magnitude: <span class="required-indicator">*</span></div>
                <input
                    [(ngModel)]="earthquakeMagnitude"
                    type="number"
                    placeholder="Enter value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="{'invalid-input': isActiveEarthquakeSelected() && earthquakeMagnitudeInvalid}"
                    min="0"
                    step="0.1"
                    (ngModelChange)="onMagnitudeChange()"
                    (focus)="magnitudeFieldTouched = true"
                />
                <div *ngIf="isActiveEarthquakeSelected() && earthquakeMagnitudeInvalid" class="error-message">
                   
                </div>
            </div>
        </div>
        <!--<div class="notif-field" [style.height]="locationsFilterDisplayedValue ? 'auto' : '60px'">
			<label [ngClass]="{'error-color' : onSaveFormWithoutFilter}">Locations Filter:</label>
			<div class="overlay-main-label">
				<div class="display-flex column w-100 mT-4">
					<mat-select *ngIf="dataset?.fields.length" [placeholder]="locationsFilterDisplayedValue"
						 class="location-address-select" (closed)="emptySearchString()">
						<div (click)="$event.stopPropagation()" class="nested-menu-search notification-search">
							<input (keydown)="$event.stopPropagation()" [(ngModel)]="filterFieldSearchString"
								[ngModelOptions]="{standalone: true}" placeholder="Search..."
								class="notification-search-input">
						</div>
						<ng-container *ngFor="let field of sortDatasetFields() | callback: filterFieldSearchFilter">
							<mat-option (click)="$event.stopPropagation()"
								*ngIf="!field.isGenerated && !field.tags?.includes('ID')">
								<mat-checkbox (change)="onChangeFilterItemForLocations(field.selected, field)"
									[checked]="field.selected" class="notif-checkbox">
									<span>{{ field.displayName ?? field.name }}</span>
								</mat-checkbox>
							</mat-option>
						</ng-container>
					</mat-select>
				</div>
				<mat-select *ngIf="!dataset?.fields.length" [disabled]="true" placeholder="No items available"
					class="location-address-select"></mat-select>
				<div class="filter-items-container">
					<ng-container *ngFor="let filterItem of locationsFilterItems"
						[ngSwitch]="filterItem.datasetField.baseType">
						<ng-container *ngSwitchCase="DatasetFieldType.NUMBER">
							<ng-container
								*ngTemplateOutlet="numberFilterTemplate; context:{fieldName: filterItem.datasetField.displayName ?? filterItem.datasetField.name, filterItem: filterItem}"></ng-container>
						</ng-container>
						<ng-container *ngSwitchCase="DatasetFieldType.TEXT">
							<ng-container
								*ngTemplateOutlet="textFilterTemplate; context:{fieldName: filterItem.datasetField.displayName ?? filterItem.datasetField.name, filterItem: filterItem}"></ng-container>
						</ng-container>
						<ng-container *ngSwitchCase="DatasetFieldType.DATE_TIME">
							<ng-container
								*ngTemplateOutlet="dateFilterTemplate; context:{fieldName: filterItem.datasetField.displayName ?? filterItem.datasetField.name, filterItem: filterItem}"></ng-container>
						</ng-container>
					</ng-container>
				</div>
			</div>
		</div>-->
        <div
            class="notif-field"
            [style.height]="
                accumulationFilterDisplayedValue ||
                layerExposeFilterDisplayedValue
                    ? 'auto'
                    : '60px'
            "
        >
            <label [ngClass]="{ 'error-color': onSaveFormWithoutFilter }"
                >Select Value (3 Max):
                <span class="required-indicator">*</span>
                <!-- <span class="field-count-indicator">
                    ({{ accumulationFilterItems.length + layerExposeFilterItems.length + (selectedFormulas?.length || 0) }}/3 selected)
                </span> -->
            </label>
            <div class="overlay-main-label">
                <!-- Main Accumulation Filter dropdown with all three sections -->
                <mat-select
                    [placeholder]="accumulationFilterDisplayedValue || 'Select field for accumulation'"
                    class="location-address-select"
                    [(ngModel)]="accumulationFilterDisplayedValue"
                    [ngModelOptions]="{ standalone: true }"
                    (selectionChange)="onAccumulationFilterChange($event)"
                    (opened)="onAccumulationDropdownOpened()"
                    #selectRef
                >
                    <div
                        (click)="$event.stopPropagation()"
                        class="nested-menu-search notification-search"
                    >
                        <input
                            (keydown)="$event.stopPropagation()"
                            [(ngModel)]="filterFieldSearchString"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="Search..."
                            class="notification-search-input"
                        />
                    </div>

                    <!-- Section 1: Accumulation Fields -->
                    <mat-optgroup label="Locations">
                        <ng-container
                            *ngFor="
                                let field of eligibleAccumulationFields
                                    | callback : filterFieldSearchFilter
                            "
                        >
                            <mat-option (click)="$event.stopPropagation()">
                                <mat-checkbox
                                    (change)="handleCheckboxChange($event, field, 'accumulation', selectRef)"
                                    [checked]="field.selected"
                                    [disabled]="getTotalSelectedCount() >= 3 && !field.selected"
                                    (click)="$event.stopPropagation()"
                                >
                                <span>{{ field.displayName ?? field.name }}</span>
                            </mat-checkbox>
                            
                            </mat-option>
                        </ng-container>
                        <mat-option
                            *ngIf="!eligibleAccumulationFields?.length"
                            disabled
                            >No accumulation fields available</mat-option
                        >
                    </mat-optgroup>

                    <!-- Section 2: Layer Expose Fields -->
                    <mat-optgroup label="Layer Exposed Fields">
                        <ng-container
                            *ngFor="
                                let field of layerExposeAccumulationFields
                                    | callback : filterFieldSearchFilter
                            "
                        >
                            <mat-option (click)="$event.stopPropagation()">
                                <mat-checkbox
                                    (change)="handleCheckboxChange($event, field, 'layerExpose',selectRef)"
                                    [checked]="field.selected"
                                    [disabled]="getTotalSelectedCount() >= 3 && !field.selected"
                                    (click)="$event.stopPropagation()"
                                    >
                                    <span>{{ field.displayName ?? field.name }}</span>
                                </mat-checkbox>

                            </mat-option>
                        </ng-container>
                        <mat-option
                            *ngIf="!layerExposeAccumulationFields?.length"
                            disabled
                            >No layer expose fields available</mat-option
                        >
                    </mat-optgroup>

                      
                    <mat-optgroup label="Formulas">
                        <ng-container
                            *ngFor="let formula of formulas; let i = index"
                        >
                            <mat-option (click)="$event.stopPropagation()">
                                <div class="formula-option">
                                    <mat-checkbox
                                    (change)="handleCheckboxChange($event, formula, 'formula', selectRef)"
                                    [checked]="isFormulaSelected(formula)"
                                    [disabled]="getTotalSelectedCount() >= 3 && !isFormulaSelected(formula)"
                                    (click)="$event.stopPropagation()"
                                >
                                    <span>{{ formula.name | decodeHtml }}</span>
                                </mat-checkbox>
                                
                                </div>
                            </mat-option>
                        </ng-container>
                        <mat-option *ngIf="!formulas?.length" disabled
                            >No formulas available</mat-option
                        >
                    </mat-optgroup> 
                </mat-select>

                <!-- Consolidated Selected Fields Section -->
                <div 
                    class="filter-items-container" 
                    *ngIf="accumulationFilterItems.length > 0 || layerExposeFilterItems.length > 0 || selectedFormulas.length > 0"
                >
                

                    <!-- Accumulation Fields -->
                    <div *ngIf="accumulationFilterItems.length > 0" class="field-section">
                        <ng-container
                            *ngFor="let filterItem of accumulationFilterItems"
                            [ngSwitch]="filterItem.datasetField.baseType"
                        >
                            <ng-container *ngSwitchCase="DatasetFieldType.NUMBER">
                                <!-- <ng-container>
                                <div class="simple-field-name">{{ filterItem.datasetField.displayName ?? filterItem.datasetField.name }}</div>
                                </ng-container> -->
                            </ng-container>
                        </ng-container>
                    </div>
                    
                    <!-- Layer Expose Fields -->
                    <div *ngIf="layerExposeFilterItems.length > 0" class="field-section">
                        <!-- <ng-container *ngFor="let filterItem of layerExposeFilterItems">
                            <div class="simple-field-name">{{ filterItem.name }}</div>
                        </ng-container> -->
                    </div>
                    
                    <!-- Formula Fields -->
                     <div *ngIf="selectedFormulas && selectedFormulas.length > 0" class="field-section formula-section">
                        <ng-container *ngFor="let formula of selectedFormulas; let i = index">
                            <!-- <div class="simple-field-name formula-field">
                                 {{ formula.name }}
                            </div> -->
                        </ng-container>
                    </div> 
                </div>

            </div>
        </div>
        <div class="notif-field">
            <label for="groups"
                >Groups: <span class="required-indicator">*</span></label
            >
            <div class="display-flex column w-100 mT-4">
                <mat-select
                    formControlName="groups"
                    id="groups"
                    [multiple]="true"
                    placeholder="Select groups"
                    (selectionChange)="onGroupSelectionChange($event)"
                    class="location-address-select"
                >
                    <mat-option
                        *ngFor="let group of allGroups"
                        [value]="group.id"
                    >
                        {{ group.name | decodeHtml }}
                        <!-- {{ group.isDefault ? "(Default)" : "" }} -->
                    </mat-option>
                </mat-select>
                <mat-error
                    *ngIf="
                        notifForm.get('groups')?.touched &&
                        notifForm.get('groups')?.errors?.required
                    "
                    class="error"
                >
                    At least one group is required
                </mat-error>
            </div>
        </div>
        <div class="notif-field" *ngIf="isActiveHailStormSelected()">
			<label for="radius">Radius: <span class="required-indicator">*</span></label>
			<div class="overlay-main-label" style="flex-direction: row !important;">
				<div class="display-flex column w-100 mT-4">
					<input matInput formControlName="radius" type="number" name="radius" id="radius"
						autocomplete="off" class=" w-100"/>
					<mat-error *ngIf="notifForm.get('radius').errors?.max" class="error">
						Exceed the maximum.
					</mat-error>
					<mat-error *ngIf="notifForm.get('radius').errors?.required" class="error">
						Required field.
					</mat-error>
					<mat-error *ngIf="notifForm.get('radius').errors?.allowPositiveOnly" class="error">
						Invalid Radius.
					</mat-error>
				</div>
				<mat-select [(value)]="distanceUnit" class="distance-unit-dropdown km-dropdown">
					<mat-option [value]="DistanceUnit.KM">{{DistanceUnit.KM}}</mat-option>
					<mat-option [value]="DistanceUnit.MILES">{{DistanceUnit.MILES}}</mat-option>
				</mat-select>
			</div>
		</div>
        <div class="notif-field email-field">
            <label for="emails">Emails</label>
            <div class="display-flex column w-100">
                <mat-form-field
                    class="example-chip-list w-100"
                    [ngClass]="{
                        invalid: emailsForm.invalid && emailsForm.touched
                    }"
                >
                    <mat-chip-list #emailsList aria-label="Fruit selection">
                        <input
                            [matChipInputFor]="emailsList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="addOnBlur"
                            (matChipInputTokenEnd)="addEmail($event)"
                            [formControl]="emailControl"
                        />
                    </mat-chip-list>
                </mat-form-field>
                <mat-error
                    *ngIf="emailsForm.invalid && emailsForm.touched"
                    class="error"
                >
                    Please enter a valid email address.
                </mat-error>
                <div class="emails-list">
                    <mat-chip
                        *ngFor="let item of alertsEmails"
                        (removed)="removeEmail(item.email)"
                    >
                        <mat-icon
                            [ngClass]="
                                item.subscribed
                                    ? 'icon-subscribed'
                                    : 'icon-unsubscribed'
                            "
                            [matTooltip]="
                                item.subscribed ? 'Unsubscribe' : 'Subscribe'
                            "
                            (click)="toggleSubscription(item.email)"
                            style="margin-right: 5px; cursor: pointer"
                        >
                            {{
                                item.subscribed
                                    ? "notifications"
                                    : "notifications_off"
                            }}
                        </mat-icon>
                        {{ item.email }}
                        <button
                            *ngIf="item.email !== creatorEmail"
                            matChipRemove
                        >
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip>
                </div>
            </div>
        </div>
        <div class="notif-field">
            <label>Personalized Subject: <span class="optional-label">(Optional)</span></label>
            <div class="display-flex column w-100 mT-4">
                <input
                    formControlName="personalizedSubject"
                    matInput
                    autocomplete="off"
                    class="w-100"
                />
                <mat-error
                    *ngIf="
                        notifForm.get('personalizedSubject').touched &&
                        notifForm.get('personalizedSubject').errors?.required
                    "
                    class="error"
                >
                    Personalized Subject is required.
                </mat-error>
                <mat-error
                    *ngIf="
                        notifForm.get('personalizedSubject').touched &&
                        notifForm.get('personalizedSubject').errors?.maxlength
                    "
                    class="error"
                >
                    Personalized Subject the maximum.
                </mat-error>
            </div>
        </div>
        <div class="content-notif-field">
            <label>Personalized Message: <span class="optional-label">(Optional)</span></label>
            <div class="display-flex column w-100 mT-4">
                <angular-editor
                    formControlName="personalizedMessage"
                    [config]="editorConfig"
                ></angular-editor>
            </div>
        </div>
        <div class="notif-field">
            <mat-checkbox formControlName="sendOneAlertDaily" class="w-100">
                <label
                    for="alertFrequency"
                    class="notif-label"
                    [ngClass]="{ 'error-color': onSaveFormWithoutFilter }"
                    [matTooltip]="'Suppress repeated alerts for same event/location'"
                    matTooltipPosition="right"
                >
                    Send only one alert daily
                </label>
            </mat-checkbox>
        </div>
        <div class="notif-field" style="margin-top: -30px;">
            <mat-checkbox formControlName="showDetailedLocationList" class="w-100">
                <label
                    for="detailedLocationList"
                    class="notif-label"
                >Include locations List
                </label>
            </mat-checkbox>
        </div>
    </form>
</div>

<ng-template
    #numberFilterTemplate
    let-fieldName="fieldName"
    let-filterItem="filterItem"
>
    <div class="filter-item">
        <div style="display: flex">
            <div class="filter-name" style="font-weight: bold">
                {{ fieldName }}:
            </div>
            <input
                [(ngModel)]="filterItem.minNumberValue"
                type="number"
                placeholder="Min"
            />
            <span class="filter-text"> to </span>
            <input
                [(ngModel)]="filterItem.maxNumberValue"
                type="number"
                placeholder="Max"
            />
        </div>
    </div>
</ng-template>
<ng-template
    #overlayNumberFilterTemplate
    let-fieldName="fieldName"
    let-filterItem="filterItem"
>
    <div class="filter-item">
        <div class="filter-name" style="font-weight: bold">
            {{ fieldName }}:
        </div>
        <input
            [(ngModel)]="filterItem.minNumberValue"
            type="number"
            placeholder="Min"
        />
        <!-- <span class="filter-text"> to </span>
		<input [(ngModel)]="filterItem.maxNumberValue" type="number" placeholder="Max"> -->
    </div>
</ng-template>

<ng-template
    #textFilterTemplate
    let-fieldName="fieldName"
    let-filterItem="filterItem"
>
    <div class="filter-item">
        <div class="filter-name" style="font-weight: bold">
            {{ fieldName }}:
        </div>
        <!-- text field low cardinality-->
        <mat-select
            *ngIf="!filterItem.datasetField.isHighCardinality; else newDeb"
            [placeholder]="filterItem.displayedSearchValue"
            (closed)="constructFilterItemDisplayValues(filterItem)"
            class="location-address-select"
        >
            <div
                (click)="$event.stopPropagation()"
                class="nested-menu-search notification-search"
            >
                <input
                    matInput
                    [(ngModel)]="filterStatisticValuesString"
                    placeholder="Search..."
                    autocomplete="off"
                    class="notification-search-input"
                />
                <mat-label *ngIf="filterItem.statistics?.values?.length === 0"
                    >No values available...</mat-label
                >
            </div>
            <ng-container *ngIf="filterItem.statistics?.values.length">
                <mat-option
                    *ngFor="
                        let value of filterItem.statistics?.values
                            | callback : filterStatisticValuesFilter
                    "
                >
                    <div (click)="$event.stopPropagation()" mat-menu-item>
                        <mat-checkbox
                            [(ngModel)]="filterItem.statisticValues[value]"
                        >
                            <span>{{ value }}</span>
                        </mat-checkbox>
                    </div>
                </mat-option>
            </ng-container>
            <mat-option
                *ngIf="!filterItem.statistics?.values.length"
                [disabled]="true"
                >No items available</mat-option
            >
        </mat-select>
        <!-- text field high cardinality-->
        <ng-template #newDeb>
            <input
                id="searchInput"
                [(ngModel)]="filterItem.searchValue"
                matInput
                placeholder="Search contains..."
                autocomplete="off"
                style="width: 94%; margin-left: 8px; margin-top: 8px"
            />
        </ng-template>
    </div>
</ng-template>

<ng-template
    #dateFilterTemplate
    let-fieldName="fieldName"
    let-filterItem="filterItem"
>
    <div class="filter-item">
        <div class="filter-name" style="font-weight: bold">
            {{ fieldName }}:
        </div>
        <mat-form-field class="date-form-field" floatLabel="never">
            <input
                [(ngModel)]="filterItem.minDateValue"
                [matDatepicker]="startAt"
                matInput
                placeholder="Start date"
                [max]="filterItem.statistics?.maxDateValue"
                [min]="filterItem.statistics?.minDateValue"
                readonly
            />
            <mat-datepicker-toggle
                [for]="startAt"
                matSuffix
            ></mat-datepicker-toggle>
            <mat-datepicker
                #startAt
                [startAt]="filterItem.statistics?.minValue"
            ></mat-datepicker>
        </mat-form-field>
        <span class="filter-text"> to </span>
        <mat-form-field
            class="date-form-field"
            appearance="legacy"
            floatLabel="never"
        >
            <input
                [(ngModel)]="filterItem.maxDateValue"
                [matDatepicker]="endAt"
                matInput
                placeholder="End date"
                [max]="filterItem.statistics?.maxDateValue"
                [min]="filterItem.statistics?.minDateValue"
                readonly
            />
            <mat-datepicker-toggle
                [for]="endAt"
                matSuffix
            ></mat-datepicker-toggle>
            <mat-datepicker #endAt></mat-datepicker>
        </mat-form-field>
    </div>
</ng-template>
